import React from 'react';
import { clientBlocks, finalStep, hometapBlocks } from 'constants/howItWorks';
import { Container } from 'library';

import TimelineBlockItem from './TimelineBlockItem/TimelineBlockItem';

import './TimelineBlock.scss';

const TimelineBlock = () => {
  const alternateArrayItems = [];
  clientBlocks.forEach((item, index) => {
    alternateArrayItems.push(item);
    if (hometapBlocks[index]) {
      alternateArrayItems.push(hometapBlocks[index]);
    }
  });
  return (
    <section className="TimelineSectionWrapper">
      <Container row justify="center" className="TimelineHeading">
        <Container>
          <h2>Simple. Straightforward. Transparent.</h2>
          <p className="TimeLineSubHeading">Here's How It Works:</p>
        </Container>
      </Container>
      <div className="Timeline">
        <ol className="TimelineList">
          {alternateArrayItems.map((block) => {
            const isClientBlock = !!block.step;
            return <TimelineBlockItem key={block.heading} isClientBlock={isClientBlock} block={block} />;
          })}

          <TimelineBlockItem isFinalBlock block={finalStep} />
        </ol>
      </div>
    </section>
  );
};

export default TimelineBlock;
